<div class="topfooter text-center p-3">
  <div class="container">
    <div class="row g-3 d-flex h-100">
      <div class="col-12 col-sm-5 col-lg-4 align-items-center text-center align-self-center">
        <div class="btn-group dropup">
          <button class="btn btn-light btn-lg text-dark dropuphover">
            <a routerLink="/products" class="buttonheight"
              queryParamsHandling="merge">{{ 'HEADER.PRODUCTS' | translate }} A - Z</a>
          </button>
          <button (click)="loadProducts();" type="button"
            class="btn btn-light btn-lg dropdown-toggle dropdown-toggle-split dropuparrow blue"
            data-bs-toggle="dropdown" aria-expanded="false">
            <span class="visually-hidden">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu rounded-3" aria-labelledby="dropdownMenuLink">
            <ng-container *ngIf="productcards">
              <a *ngFor="let product of productcards" class="dropdown-item" [routerLink]='product.link'
                queryParamsHandling="merge" [queryParams]="{ product: product.title }">{{ product.title }}</a>
            </ng-container>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-sm-7 d-block d-lg-none text-start footercolumn justify-content-center align-items-center align-self-center">
        <div class="row g-1">
          <div class="col-6 col-sm-6">
            <p class="h5 fw-bold footertitle">Corporate</p>
            <ul class="list-unstyled text-start">
              <li><a class="footerlink" queryParamsHandling="merge"
                  routerLink="/company/careers">{{ 'FOOTER.CAREERS' | translate }}</a></li>
              <li><a class="footerlink" queryParamsHandling="merge"
                  routerLink="/company/locateapartner">{{ 'FOOTER.LOCATEPARTNER' | translate }}</a></li>
              <li><a class="footerlink" queryParamsHandling="merge" routerLink="/company/myveex">MyVeEX</a></li>
            </ul>
          </div>
          <div class="col-6 col-sm-6">
            <p class="h5 fw-bold footertitle">Discover</p>
            <ul class="list-unstyled text-start">
              <li><a class="footerlink" queryParamsHandling="merge" routerLink="/apps"
                  [queryParams]="{ product: 'Apps' }">{{ 'FOOTER.APPS' | translate }}</a></li>
              <li><a class="footerlink" href="https://kb.veexinc.com/en/knowledge"
                  target="_blank">{{ 'FOOTER.KNOWLEDGEBASE' | translate }}</a></li>
              <li><a class="footerlink" href="https://resources.veexinc.com" target="_blank">Resources</a></li>
            </ul>
          </div>
          <div class="col-6 col-sm-6">
            <p class="h5 fw-bold footertitle">Support</p>
            <ul class="list-unstyled text-start">
              <li><a class="footerlink" queryParamsHandling="merge"
                  routerLink="/company/contactus">{{ 'FOOTER.CONTACTUS' | translate }}</a></li>
              <li><a class="footerlink" queryParamsHandling="merge" routerLink="/i"
                  [queryParams]="{ comments: null }">{{ 'BUTTON.DOWNLOAD' | translate }}</a></li>
              <li><a class="footerlink" queryParamsHandling="merge"
                  routerLink="/company/howtobuy">{{ 'HOWTOBUY.TITLE' | translate }}</a></li>
            </ul>
          </div>
          <div class="col-6 col-sm-6">
            <p class="h5 fw-bold footertitle">Follow Us</p>
            <ul class="list-unstyled text-start">
              <li><a class="footerlink" queryParamsHandling="merge"
                  routerLink="/newsandevents/press-releases">{{ 'FOOTER.PRESSRELEASES' | translate }}</a></li>
              <li><a class="footerlink" queryParamsHandling="merge"
                  routerLink="/newsandevents/webinars">{{ 'FOOTER.WEBINARS' | translate }}</a></li>
              <li class="mt-2">
                <a class="footerlink me-1" target="_blank" href="https://www.facebook.com/VeEX-Inc-105639244427066/"
                  aria-label="Facebook"><i class="bi bi-facebook"></i></a>
                <a class="footerlink mx-1" target="_blank" href="https://www.instagram.com/veexinc/"
                  aria-label="Instagram"><i class="bi bi-instagram"></i></a>
                <a class="footerlink mx-1" target="_blank" href="https://www.linkedin.com/company/veexinc/"
                  aria-label="LinkedIn"><i class="bi bi-linkedin"></i></a>
                <a class="footerlink mx-1" target="_blank" href="https://twitter.com/veexinc/" aria-label="Twitter"><i
                    class="bi bi-twitter"></i></a>
                <a class="footerlink ms-1" target="_blank" href="https://www.youtube.com/user/VeEXinc/"
                  aria-label="YouTube"><i class="bi bi-youtube"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-2 d-none d-lg-block text-start footercolumn">
        <p class="h5 fw-bold footertitle">{{ 'FOOTER.CORPORATE' | translate }}</p>
        <ul class="list-unstyled text-start columnheight">
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/aboutus">{{ 'FOOTER.ABOUTUS' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/awards">{{ 'FOOTER.AWARDS' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/careers">{{ 'FOOTER.CAREERS' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/locateapartner">{{ 'FOOTER.LOCATEPARTNER' | translate }}</a>
          </li>
          <li><a class="footerlink" queryParamsHandling="merge" routerLink="/company/myveex">MyVeEX</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/customers">{{ 'FOOTER.CUSTOMERS' | translate }}</a></li>


        </ul>
      </div>
      <div class="col-md-2 d-none d-lg-block text-start footercolumn">
        <p class="h5 fw-bold footertitle">{{ 'FOOTER.DISCOVER' | translate }}</p>
        <ul class="list-unstyled text-start columnheight">
          <li><a class="footerlink" queryParamsHandling="merge" routerLink="/apps"
              [queryParams]="{ product: 'Apps' }">{{ 'FOOTER.APPS' | translate }}</a></li>
          <li><a class="footerlink" href="https://kb.veexinc.com/en/knowledge"
              target="_blank">{{ 'FOOTER.KNOWLEDGEBASE' | translate }}</a></li>
          <!-- <li><a class="footerlink" href="https://shop.veexinc.com/"
              target="_blank">{{ 'FOOTER.ONLINESHOP' | translate }}</a></li> -->
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/menu/productlist">{{ 'FOOTER.PRODUCTS' | translate }}</a></li>
          <li><a class="footerlink" href="https://resources.veexinc.com" target="_blank">Resources</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/solutions">{{ 'FOOTER.SOLUTIONS' | translate }}</a></li>
        </ul>
      </div>
      <div class="col-md-2 d-none d-lg-block text-start footercolumn">
        <p class="h5 fw-bold footertitle">{{ 'FOOTER.SUPPORT' | translate }}</p>
        <ul class="list-unstyled text-start columnheight">
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/contactus">{{ 'FOOTER.CONTACTUS' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge" routerLink="/i"
              [queryParams]="{ comments: null }">{{ 'BUTTON.DOWNLOAD' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/howtobuy">{{ 'HOWTOBUY.TITLE' | translate }}</a>
          </li>
          <!-- <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/company/financing">{{ 'FOOTER.FINANCING' | translate }}</a></li> -->
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/support/productregistration">{{ 'FOOTER.PRODUCTREG' | translate }}</a>
          </li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/support/rmarequest">{{ 'FOOTER.RMAREQ' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/support/software">{{ 'FOOTER.SWUPDATE' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/support/supportbulletins">{{ 'FOOTER.SUPPORTBULLETIN' | translate }}</a></li>
              <li><a class="footerlink" queryParamsHandling="merge" routerLink="/support/end-of-life-eol-policy-statement">End of Life (EOL) Policy</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/support/warranty">{{ 'FOOTER.WARRANTY' | translate }}</a></li>
        </ul>
      </div>
      <div class="col-md-2 d-none d-lg-block text-start footercolumn">
        <p class="h5 fw-bold footertitle">{{ 'FOOTER.FOLLOWUS' | translate }}</p>
        <ul class="list-unstyled text-start columnheight">
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/newsandevents/events">{{ 'FOOTER.EVENTS' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/newsandevents/multimedia">{{ 'FOOTER.MULTIMEDIA' | translate }}</a>
          </li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/newsandevents/press-releases">{{ 'FOOTER.PRESSRELEASES' | translate }}</a></li>
          <li><a class="footerlink" queryParamsHandling="merge"
              routerLink="/newsandevents/webinars">{{ 'FOOTER.WEBINARS' | translate }}</a></li>
          <li class="mt-2">
            <a class="footerlink me-1" target="_blank" href="https://www.facebook.com/VeEX-Inc-105639244427066/"
              aria-label="Facebook"><i class="bi bi-facebook"></i></a>
            <a class="footerlink mx-1" target="_blank" href="https://www.instagram.com/veexinc/"
              aria-label="Instagram"><i class="bi bi-instagram"></i></a>
            <a class="footerlink mx-1" target="_blank" href="https://www.linkedin.com/company/veexinc/"
              aria-label="LinkedIn"><i class="bi bi-linkedin"></i></a>
            <a class="footerlink mx-1" target="_blank" href="https://twitter.com/veexinc/" aria-label="Twitter"><i
                class="bi bi-twitter"></i></a>
            <a class="footerlink ms-1" target="_blank" href="https://www.youtube.com/user/VeEXinc/"
              aria-label="YouTube"><i class="bi bi-youtube"></i></a>
            </li>
          <!-- <li><a class="footerlink" routerLink="/cusportal">CUSTOMER PORTAL</a></li> -->
          <!-- <li *ngIf="_httpService.production()"><a class="footerlink" routerLink="/vxhelper">VXHELPER</a></li> -->
        </ul>
      </div>
    </div>
  </div>
</div>
<nav class="navbar navbar-expand-xl bg-dark px-2" id="bottomnavtop" data-bs-theme="dark">
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="veexNavbar0">
      <ul class="navbar-nav" role="tablist">
        <li *ngIf="cnlink || checkHost" class="nav-item" role="presentation" data-bs-toggle="collapse"
          data-bs-target=".navbar-collapse.show">
          <a role="tab" class="nav-link text-truncate" href="https://beian.miit.gov.cn/"
            target="_blank">{{ 'link' | translate }}</a>
        </li>
        <li class="nav-item" role="presentation" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a role="tab" class="nav-link text-truncate" routerLink="/company/browsercompatibility"
            queryParamsHandling="merge">{{ 'FOOTER.BROWSERCOMPAT' | translate }}</a>
        </li>
        <li class="nav-item" role="presentation" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a role="tab" class="nav-link text-truncate" routerLink="/company/privacypolicy"
            queryParamsHandling="merge">{{ 'FOOTER.PRIVPOLICY' | translate }}</a>
        </li>
        <li class="nav-item" role="presentation" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a role="tab" class="nav-link text-truncate" routerLink="/company/rohscompliance"
            queryParamsHandling="merge">{{ 'FOOTER.ROHSCOMPLIANCE' | translate }}</a>
        </li>
        <li class="nav-item" role="presentation" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a role="tab" class="nav-link text-truncate" routerLink="/sitemap"
            queryParamsHandling="merge">{{ 'FOOTER.SITEMAP' | translate }}</a>
        </li>
        <li class="nav-item" role="presentation" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a role="tab" class="nav-link text-truncate" routerLink="/company/termsofuse"
            queryParamsHandling="merge">{{ 'FOOTER.TERMSOFUSE' | translate }}</a>
        </li>
      </ul>
    </div>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#veexNavbar0"
      aria-controls="veexNavbar0" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <span class="navbar-brand text-light copyright small text-center">© {{ year }} VeEX Inc.
      {{ 'FOOTER.ALLRIGHTS' | translate }}.</span>
    <span class="align-middle navbar-brand">
      <app-tools-changelang></app-tools-changelang>
    </span>
  </div>
</nav>
